import React, { ReactElement } from "react";
import ReactDOM from 'react-dom';
import App from 'src/app/App';
import { ConfigProvider } from './@bootstrap/Config';
import './@bootstrap/template/styles/reset.scss';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider>
      <App />
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
